import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
// 登录验证
export default new Vuex.Store({
    state: {
        user: false
    },
    mutations: {
        // 登录
        login(state, user) {
            state.user = user;
            const now = new Date();
            const oneHourLater = new Date(now.getTime() + 60 * 60 * 1000);
            localStorage.setItem("userInfo", oneHourLater.toISOString());
        },
        // 退出
        logout(state, user) {
            state.user = "";
            localStorage.setItem("userInfo", "");
        }
    }
})


// WEBPACK FOOTER //
// ./src/vuex/store.js